<div class="panel-body ">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
     <div class="panel-body ">
       <div class="row table-responsive">
      <table id="allegations-table" class="table table-condensed table-striped">
     <thead>
       <tr>
         <th id="V122c">
           <span class="field-code ">V122c json='allegations.pleadingType'</span>
           Pleading Type <br> 
           <span class="field-code ">V122c json='allegations.clockDate'</span>
           And Clock Date
         </th>
         <th id="V121c">
           <span class="field-code ">V121c json='allegations.allegation'</span>
             Allegation <br>
             <span class="field-code ">V121c json='allegations.offenseDate'</span>
             Offense Date
           </th>
         <th id="V121c">
           <span class="field-code ">V121c json='allegations.result'</span>
             Result
           </th>
           <th>
              <span class="field-code "> json='allegations.more'</span>
                More
            </th>
          </tr>
     </thead>
     <tbody *ngFor="let allegation of juvenileCase.getAllegationsList(); let templIndex = index;">
       <tr >
        <td id="{{'juvenile-caseDetails-events-' + templIndex + '-pleadingType'}}">
          {{allegation.getPleadingTypeDesc()}} <br>
          {{allegation.getPleadingDate() | date:'MM/dd/yyyy'}} {{allegation.getPleadingTime()}}</td>
        <td id="{{'juvenile-caseDetails-events-' + templIndex + '-allegationDescription'}}">
          {{allegation.getAllegationDescription()}} <br>        
          {{allegation.getOffenseDate() | date:'MM/dd/yyyy'}} </td>
        <td id="{{'civil-caseDetails-attorneys-' + templIndex + '-result'}}">{{allegation.getAdjResult()}}<br>{{allegation.getDispResult()}}<br>
            <span *ngIf="allegation.getAmdAllDesc()!==''"><B>Amended To:</B>{{allegation.getAmdAllDesc()}}</span><br>
             <span *ngIf="allegation.getReceivingCountyName()!==''"><B>Change Venue to County:</B>{{allegation.getReceivingCountyName()}}</span></td>
        <td id="{{'civil-caseDetails-attorneys-' + templIndex + '-more'}}">

            <span *ngIf="allegation.getChangeVenue()!==''" [popover]="popTemplateForChangeVenue" placement="left" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-transfer"></i></span>       
            <ng-template #popTemplateForChangeVenue><pre [innerHtml]="allegation.getChangeVenue()"></pre></ng-template>

            <!-- <span [popover]=templIndex placement="left"><i class="fa fa-info-circle"></i></span>  -->
            <span *ngIf="allegation.getNotes()!==''" [popover]="popTemplate" placement="left" triggers="click" outsideClick="true"><i class="glyphicon glyphicon-comment"></i></span>       
            <ng-template #popTemplate><pre [innerHtml]="allegation.getNotes()"></pre></ng-template>         
          <!-- <span *ngIf="allegation.getNotes()!==''" popover='{{allegation.getNotes()}}' ><i class="glyphicon glyphicon-comment"></i></span></td> -->
      </tr> 
      <tr >
        <td colspan="4">
            <a (click)="showAdditionalAllegationInfoFlags[templIndex] = !showAdditionalAllegationInfoFlags[templIndex]">{{showAdditionalAllegationInfoFlags[templIndex] ? '>Hide Additional Information' : '>Show Additional Information'}}</a>
            <div *ngIf="showAdditionalAllegationInfoFlags[templIndex]" class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top" >
             <allegations-additional-info-view [allegations]="allegation"></allegations-additional-info-view>
             </div>            
        </td>   
      </tr>    
     </tbody>
     </table>
     </div>
    </div>
   </div>
 </div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations.component.html